<template>
  <transition name="element-confirm">
    <div class="element-confirm" v-if="element && element.value == 1">
      <div class="container">
        <div class="close" @click="closeConfirm" v-if="haveClose"></div>
        <main><slot name="message" /></main>
        <footer>
          <div class="element-confirm-interface false" v-if="$slots.false" @click="closeConfirm">
            <slot name="false" />
          </div>
          <div class="element-confirm-interface true" v-if="$slots.true" @click="closeConfirm">
            <slot name="true" />
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: [ "elementId", "haveClose" ],
  computed: {
    element(){
      return this.$store.getters[ "elementConfirm/GET_ITEM" ]({ elementId: this.elementId });
    }
  },
  created(){
    if( !this.$store.state.elementConfirm ){
      this.$store.registerModule( "elementConfirm", {
        namespaced: true,
        state: {
          items: {}
        },
        getters: {
          GET_ITEM: state => payload => {
            return state.items[ payload.elementId ];
          }
        },
        mutations: {
          SET_ITEM: ( state, payload ) => {
            this.$set( state.items, payload.elementId, { ...payload, value: 1 });
          },
          UNSET_ITEM: ( state, payload ) => {
            this.$set( state.items, payload.elementId );
          },
          SET_VALUE: ( state, payload ) => {
            state.items[ payload.elementId ].value = payload.value;
          },
        },
      });
    };
  },
  methods: {
    closeConfirm(){
      this.$store.commit( "elementConfirm/SET_VALUE", { elementId: this.elementId, value: 0 })
    }
  }
}
</script>
